import { render, staticRenderFns } from "./alignedPlan.vue?vue&type=template&id=98c3a9d6&scoped=true&"
import script from "./alignedPlan.vue?vue&type=script&lang=ts&setup=true&"
export * from "./alignedPlan.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./alignedPlan.vue?vue&type=style&index=0&id=98c3a9d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c3a9d6",
  null
  
)

export default component.exports